document.addEventListener("DOMContentLoaded", () => {
  const quizPopupTriggers = document.querySelectorAll('.coverage-checker-popup-trigger');

  quizPopupTriggers.forEach(trigger => {
    const quizSection = document.getElementById('quiz-section');

    if (quizSection) {
      trigger.addEventListener('click', () => {
        quizSection.scrollIntoView({ behavior: 'smooth' });
      });
    } else {
      trigger.addEventListener('click', () => {
        const plan = trigger.dataset.plan;

        window.coverageCheckerData.plan = plan;
        showCoverageCheckerPopup(window.coverageCheckerData);

        window.coverageCheckerData.previousType = window.coverageCheckerData.type;
        window.coverageCheckerData.type = 'popup';

        showCoverageCheckerStep1(window.coverageCheckerData);
      });
    }
  });

  if (window.innerWidth <= 650) {
    const quizPopupKey = `quizPopupLastShown`;

    setTimeout(() => {
      const now = Date.now();
      const last = parseInt(localStorage.getItem(quizPopupKey), 10);

      if (!last || now - last > 1 * 60 * 60 * 1000) {
        showCoverageCheckerPopup(window.coverageCheckerData);

        window.coverageCheckerData.previousType = window.coverageCheckerData.type;
        window.coverageCheckerData.type = 'popup';

        showCoverageCheckerStep1(window.coverageCheckerData);
        localStorage.setItem(quizPopupKey, now);
      }
    }, 2 * 1000);
  }
});

const showCoverageCheckerPopup = (d) => {
  d.popupOpen = true;
  const quizPopup = document.getElementById('coverage-checker-popup');
  quizPopup.style.display = 'flex';

  lenis.stop();
  openCoverageChecker();
}

const hideCoverageCheckerPopup = (d) => {
  d.popupOpen = false;
  const quizPopup = document.getElementById('coverage-checker-popup');
  quizPopup.style.display = 'none';

  lenis.start();
}
